export const ADD_RIGHTS_QUERY_KEY = "addRights";

export enum AddRightsStatusEnum {
  Active = "Active",
  Expired = "Expired",
  ActionPending = "Action-Pending",
  Upcoming = "Upcoming",
  All = "",
  Cancelled = "Cancelled",
  Withdrawn = "Withdrawn",
  Pending = "Pending"
}

export const AddRightsStatus = {
  All: {
    label: "All",
    value: AddRightsStatusEnum.All,
  },
  Pending: {
    label: "Pending",
    value: AddRightsStatusEnum.Pending
  },
  ActionPending: {
    label: "Action Pending",
    value: AddRightsStatusEnum.ActionPending,
  },
  Upcoming: {
    label: "Upcoming",
    value: AddRightsStatusEnum.Upcoming,
  },
  Active: {
    label: "Active",
    value: AddRightsStatusEnum.Active,
  },
  Expired: {
    label: "Expired",
    value: AddRightsStatusEnum.Expired,
  },
  Cancelled: {
    label: "Cancelled",
    value: AddRightsStatusEnum.Cancelled
  },
  Withdrawn: {
    label: "Withdrawn",
    value: AddRightsStatusEnum.Withdrawn
  }
};
